import { useState } from "react"
import { string } from "prop-types"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { Button } from "@planningcenter/doxy-web"
import {
  useApiRead,
  SessionApiResource,
} from "source/shared/SessionApiResource"
import { useCacheHydrate } from "source/shared/react-cache-but-its-a-context"
import { ActionBar } from "source/shared/components"
import { Date } from "source/shared/DatetimeFmt"
import { Modal, useOpenModal } from "source/shared/components/Modal"
import { memberApiUrl } from "source/groups/my/groups/members/show"

DigestInvite.propTypes = {
  name: string.isRequired,
  emailAddress: string.isRequired,
  groupId: string.isRequired,
  membershipId: string.isRequired,
}

export function DigestInvite(props) {
  return (
    <Modal>
      <InviteActionBar {...props} />
      <Modal.Show>
        <Modal.Header>Email invite sent</Modal.Header>
        <Modal.Body>
          <p>
            An email invite has been sent to {props.emailAddress} to join the
            daily email digest. {props.name} can unsubscribe at any time by
            clicking the unsubscribe link in the digest emails.
          </p>
          <Modal.Footer>
            <Modal.Close className="btn">OK</Modal.Close>
          </Modal.Footer>
        </Modal.Body>
      </Modal.Show>
    </Modal>
  )
}

InviteActionBar.propTypes = DigestInvite.propTypes

function InviteActionBar({ groupId, membershipId }) {
  const subscriptionUrl = `${memberApiUrl(groupId, membershipId)}/digest_subscription?fields=[GroupDigestSubscription]=activated_at,invited_at`
  const response = useApiRead(subscriptionUrl)
  const reloadSubscription = useCacheHydrate(
    SessionApiResource,
    subscriptionUrl,
  )
  const [inFlight, setInFlight] = useState(false)
  const openModal = useOpenModal()

  if (response.errors) return null

  const subscription = response.data
  const { activated_at, invited_at } = subscription.attributes
  const subscribed = !!activated_at
  const invited = !!invited_at

  const sendInvite = () => {
    setInFlight(true)
    sessionApiClient
      .post(`${memberApiUrl(groupId, membershipId)}/digest_invite`)
      .then(() => {
        openModal()
        reloadSubscription()
      })
      .catch((_error) => {
        window.alert("Oops! Something went wrong. Please try again.")
      })
      .finally(() => {
        setInFlight(false)
      })
  }

  return (
    <ActionBar.Pane>
      <ActionBar.Column>
        <ActionBar.Description>Daily digest email</ActionBar.Description>
        {!subscribed && (
          <p className="m-0 fs-5 c-tint2">
            {invited ? (
              <>
                Invited <Date start={invited_at} year={true} />
              </>
            ) : (
              "Not subscribed"
            )}
          </p>
        )}
      </ActionBar.Column>
      <ActionBar.Action>
        {subscribed ? (
          <p className="m-0 fs-4 c-tint2">
            Subscribed <Date start={activated_at} year={true} />
          </p>
        ) : (
          <Button
            text={invited ? "Re-send invite" : "Send invite"}
            size="sm"
            variant="outline"
            isLoading={inFlight}
            disabled={inFlight}
            onClick={sendInvite}
          />
        )}
      </ActionBar.Action>
    </ActionBar.Pane>
  )
}
